import { SimilarByPatternSettingsTypes } from '../types';

export const buildSimilarByPatternSettingsPayload = (
  payload: Partial<SimilarByPatternSettingsTypes.SimilarByPatternSettings>
): Partial<SimilarByPatternSettingsTypes.SimilarByPatternSettings> => {
  const payloadData = {
    numberOfResultsToDisplay: payload.numberOfResultsToDisplay,
  };

  return payloadData;
};
